<template>
  <div class="clock-in-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>小程序打卡数据列表</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="refreshData">刷新</el-button>
      </div>

      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="search-form-inline">
          <el-form-item label="打卡日期">
            <el-date-picker
              v-model="searchForm.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              :clearable="true"
              style="width: 160px;"
              @change="handleSearch"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
            <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="clockInList"
        v-loading="loading"
        border
        height="570"
        style="width: 100%">
        <el-table-column
          align="center"
          header-align="center"
          label="序号"
          type="index"
          width="70"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="id"
          label="记录ID"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="content"
          label="打卡类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="上报人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="eventTime"
          label="打卡时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="imageUrl"
          label="打卡图片"
          align="center">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.imageUrl"
              style="width: 80px; height: 80px"
              :src="getImageUrl(scope.row.imageUrl)"
              :preview-src-list="[getImageUrl(scope.row.imageUrl)]"
              fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <span v-else class="no-image">无</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          fixed="right"
          align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)">修改</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="total > 0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 修改对话框 -->
    <el-dialog
      title="修改打卡记录"
      :visible.sync="editDialogVisible"
      width="500px"
      @close="handleEditDialogClose">
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
        <el-form-item label="打卡类型" prop="content">
          <el-select v-model="editForm.content" placeholder="请选择打卡类型" style="width: 100%;">
            <el-option
              v-for="item in typeOptions"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打卡时间" prop="eventTime">
          <el-date-picker
            v-model="editForm.eventTime"
            type="datetime"
            placeholder="选择打卡时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmitEdit" :loading="editLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchFormOptions,
  fetchHomeRecords,
  fetchRegisterRecordDetail,
  updateRegisterRecord,
  deleteRegisterRecord
} from '@/api/modules/registerRecord'

export default {
  name: 'MiniprogramClockInData',
  data() {
    return {
      clockInList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        date: ''
      },
      editDialogVisible: false,
      editLoading: false,
      editForm: {
        id: '',
        content: '',
        eventTime: ''
      },
      editRules: {
        content: [{ required: true, message: '请选择打卡类型', trigger: 'change' }],
        eventTime: [{ required: true, message: '请选择打卡时间', trigger: 'change' }]
      },
      editFormRef: null,
      // 打卡类型选项列表，从接口动态获取
      typeOptions: []
    }
  },
  created() {
    this.fetchClockInData()
    this.fetchFormOptions()
  },
  methods: {
    /**
     * 从后端接口获取表单选项数据（打卡类型列表和上报人列表）
     */
    async fetchFormOptions() {
      try {
        const data = await fetchFormOptions()
        this.typeOptions = data.typeOptions || []
      } catch (error) {
        console.error('获取表单选项失败:', error)
        // 使用默认值作为兜底
        this.typeOptions = [
          { name: '晒衣' },
          { name: '铲屎' },
          { name: '换水' },
          { name: '装粮' },
          { name: '丢垃圾' },
          { name: '遛狗' },
          { name: '刷牙' }
        ]
      }
    },
    /**
     * 处理图片 URL，如果包含 mini-program-static 前面的路径则替换为空
     * @param {string} url 原始图片地址
     * @returns {string} 处理后的图片完整地址
     */
    getImageUrl(url) {
      if (!url) return ''
      // 如果 mini-program-static 前面还有内容（如域名或IP），则替换为空
      const processedUrl = url.replace(/.*mini-program-static\//, '/mini-program-static/')
      // 拼接生产环境域名
      return `https://lyqanddyl.com${processedUrl}`
    },
    async fetchClockInData() {
      this.loading = true
      try {
        const params = {}
        if (this.searchForm.date) {
          params.date = this.searchForm.date
        }
        
        const data = await fetchHomeRecords(params)
        const allRecords = data.list || []
        
        this.total = allRecords.length
        const startIndex = (this.currentPage - 1) * this.pageSize
        const endIndex = startIndex + this.pageSize
        this.clockInList = allRecords.slice(startIndex, endIndex)
      } catch (error) {
        console.error('获取打卡数据失败:', error)
        this.clockInList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchClockInData()
    },
    handleReset() {
      this.searchForm = {
        date: ''
      }
      this.currentPage = 1
      this.fetchClockInData()
    },
    handleView(row) {
      if (row.imageUrl) {
        this.$alert(`<img src="${this.getImageUrl(row.imageUrl)}" style="max-width: 100%;">`, `打卡详情 - ${row.name}`, {
          dangerouslyUseHTMLString: true,
          customClass: 'image-preview-dialog'
        })
      } else {
        this.$toast.info('暂无打卡图片')
      }
    },
    async handleEdit(row) {
      try {
        const record = await fetchRegisterRecordDetail(row.id)
        // 转换为日期时间格式用于编辑
        const dateStr = record.eventTime.slice(0, 10)
        const timeStr = record.eventTime.slice(11, 19)
        this.editForm = {
          id: record.id,
          content: record.type,
          eventTime: `${dateStr} ${timeStr}`
        }
        this.editDialogVisible = true
      } catch (error) {
        console.error('获取记录详情失败:', error)
      }
    },
    handleEditDialogClose() {
      this.editForm = {
        id: '',
        content: '',
        eventTime: ''
      }
      if (this.$refs.editFormRef) {
        this.$refs.editFormRef.resetFields()
      }
    },
    handleSubmitEdit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        
        this.editLoading = true
        try {
          await updateRegisterRecord(this.editForm.id, {
            type: this.editForm.content,
            eventTime: this.editForm.eventTime
          })
          this.$toast.success('修改成功')
          this.editDialogVisible = false
          this.fetchClockInData()
        } catch (error) {
          console.error('修改失败:', error)
        } finally {
          this.editLoading = false
        }
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确定要删除这条打卡记录吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        await deleteRegisterRecord(row.id)
        this.$toast.success('删除成功')
        this.fetchClockInData()
      } catch (error) {
        if (error === 'cancel') {
          return
        }
        console.error('删除失败:', error)
      }
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchClockInData()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.fetchClockInData()
    },
    refreshData() {
      this.fetchClockInData()
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    }
  }
}
</script>

<style scoped>
.clock-in-container {
  /* 撑满内容区，滚动下沉到模块内部；内边距由内容区统一提供 */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
}

.search-form {
  margin-bottom: 20px;
  padding: 15px;
  background-color: var(--surface-2);
  border-radius: 4px;
}

.search-form-inline {
  margin-bottom: 0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--surface-2);
  color: #909399;
  font-size: 24px;
}

.no-image {
  color: #909399;
  font-size: 12px;
}
</style>

<style>
.image-preview-dialog {
  width: 80%;
  max-width: 800px;
}
</style>
